import { createContext, useReducer } from 'react';
const INITIAL_VALUE = {
  opener: false,
  scrollValue: 0,
  aboutHeight: null,
  margin: 'ml-[10rem]',
};

export const context = createContext(INITIAL_VALUE);
const reducer = (state, action) => {
  switch (action.type) {
    case 'OPENERCLOSER': {
      return {
        ...state,
        opener: action.open,
      };
    }
    case 'ABOUT_HEIGHT': {
      return {
        aboutHeight: action.aboutHeight,
      };
    }
    case 'MARGIN': {
      return {
        ...state,
        margin: action.margin,
      };
    }
    default:
      return {
        state,
      };
  }
};
const ContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_VALUE);
  return (
    <context.Provider
      value={{
        margin: state.margin,
        opener: state.opener,
        aboutHeight: state.aboutHeight,
        dispatch,
      }}
    >
      {props.children}
    </context.Provider>
  );
};

export default ContextProvider;
